export function resolveSelectedRows(
  selectedKeys: string[],
  displayData: unknown[],
  resolveRowKey: (row: Record<string, unknown>, rowIndex: number) => string,
): Record<string, unknown>[] {
  if (selectedKeys.length === 0) return [];

  const keySet = new Set(selectedKeys);
  const rows: Record<string, unknown>[] = [];

  (displayData as Record<string, unknown>[]).forEach((row, index) => {
    const key = resolveRowKey(row, index);
    if (keySet.has(key)) {
      rows.push(row);
    }
  });

  return rows;
}
